import * as yup from 'yup';

export type LoginFormValues = {
  email: string;
  password: string;
};

export const loginFormSchema = yup.object().shape({
  email: yup
    .string()
    .email('Please provide correct email.')
    .required('Email is required.'),
  password: yup
    .string()
    .min(3, 'Password needs to be 3-32 characters long.')
    .max(32, 'Password needs to be 3-32 characters long.')
    .required('Password is required'),
});
